
import { Typography } from "@mui/material";
import { useUserContext } from "../../contexts/UserContext";
import { INavigationLink } from "../../interfaces/INavigation";
import Link from "./Link";
import { useEnvironmentContext } from "../../contexts/EnvironmentContext";
import IPartnerPms from "../../interfaces/IPartnerPms";


interface INavigationCategoryProps {
    title: string | undefined;
    aliasList: string[];
    items: INavigationLink[];
    expandedLinks: INavigationLink[];
    handleChangeExpandedLinks: (navigationLink: INavigationLink) => void;
    handleCloseNavigation: () => void;
}


const Category: React.FC<INavigationCategoryProps> = ({ 
    title,
    aliasList,
    items,
    expandedLinks,
    handleChangeExpandedLinks,
    handleCloseNavigation
}) => {
    const { environment } = useEnvironmentContext();
    const { userPermissions } = useUserContext();

    if (aliasList.filter(alias => userPermissions.includes(alias)).length === 0) {
        return null;
    }
    
    return (
        <>
            {
                title && <Typography component='h5' variant='subtitle2' className='text-category' key={`navigationcategory-${title}`}>
                    {environment.partnerPms[title as keyof(IPartnerPms)].toString()}
                </Typography>
            }

            {
                items.map((item: INavigationLink) => {
                    return (
                        <Link
                            link={item}
                            expandedLinks={expandedLinks}
                            handleChangeExpandedLinks={handleChangeExpandedLinks}
                            handleCloseNavigation={handleCloseNavigation}
                            key={`navigationitem-${item.alias}`}
                        />
                    );
                })
            }
        </>
    );
}


export default Category;